{
	"name": "did-setup",
	"version": "3.2.0-U",
	"private": true,
	"dependencies": {
		"i18next": "^25.2.1",
		"lottie-react": "^2.4.1",
		"react": "^18.3.1",
		"react-dom": "^18.3.1",
		"react-i18next": "^15.5.3",
		"react-select": "^5.10.1",
		"react-simple-keyboard": "^3.8.84",
		"sass": "^1.89.2",
		"simplebar-react": "^3.3.1",
		"workbox-build": "^7.4.0",
		"zxcvbn": "^4.4.2"
	},
	"devDependencies": {
		"@types/jest": "^29.5.14",
		"@types/node": "^24.12.4",
		"@types/react": "^18.3.23",
		"@types/react-dom": "^18.3.7",
		"@types/zxcvbn": "^4.4.5",
		"@vitejs/plugin-react": "^6.0.2",
		"concurrently": "^10.0.3",
		"express": "^4.21.2",
		"http-proxy-middleware": "^3.0.5",
		"prettier": "^3.6.2",
		"typescript": "^5.9.3",
		"vite": "^8.0.16"
	},
	"scripts": {
		"dev": "concurrently \"node scripts/proxy.js\" \"vite\"",
		"checkTranslations": "node scripts/checkTranslations.js",
		"workbox": "node scripts/build-sw.js",
		"build": "tsc && vite build && npm run workbox",
		"lint": "eslint src --ext ts,tsx --report-unused-disable-directives --max-warnings 0",
		"lint:fix": "eslint src --fix --ext ts,tsx --report-unused-disable-directives --max-warnings 0",
		"preview": "vite preview"
	},
	"eslintConfig": {
		"extends": [
			"react-app",
			"react-app/jest"
		]
	},
	"browserslist": {
		"production": [
			">0.2%",
			"not dead",
			"not op_mini all"
		],
		"development": [
			"last 1 chrome version",
			"last 1 firefox version",
			"last 1 safari version"
		]
	}
}
